<script>
	export let dataMapped;
	import {Notebook} from '@manaakiwhenua/frag-svelte';
    import {default as maoriFactsheet} from '../notebooks/@ridgenb/maori-factsheet';

	let cells = ['subHeaderBar6', 'soilManagementFactors1', 'soilManagementFactors2', 'soilManagementFactors3', 'tableRunoff'];
	$: overrides = new Map([['dataMapped', dataMapped]]);
</script>

<style>
    .soil-management-factors :global(.frag-notebook) {
        display: grid;
        grid-template-areas:
                "header header header"
                "factor1 factor2 factor3"
                "factor1 factor2 runoff";
    }

    @media screen and (max-width: 767px) {
        .soil-management-factors :global(.frag-notebook) {
            grid-template-areas:
                "header header"
                "factor1 factor2"
                "factor3 factor3"
                "runoff runoff";
        }
    }

    @media screen and (max-width: 500px) {
        .soil-management-factors :global(.frag-notebook) {
            display: block;
        }
    }

    .soil-management-factors :global([data-cell=subHeaderBar6]) {
        grid-area: header;
    }

    .soil-management-factors :global([data-cell=soilManagementFactors1]) {
        grid-area: factor1;
    }

    .soil-management-factors :global([data-cell=soilManagementFactors2]) {
        grid-area: factor2;
    }

    .soil-management-factors :global([data-cell=soilManagementFactors3]) {
        grid-area: factor3;
    }

    .soil-management-factors :global([data-cell=tableRunoff]) {
        grid-area: runoff;
    }

    .soil-management-factors :global([data-cell=tableRunoff] table) {
        width: 100%;
    }

</style>

<div class="soil-management-factors">
    <Notebook notebook={maoriFactsheet} cells={cells} overrides={overrides}></Notebook>
</div>
